import { render, staticRenderFns } from "./FormArray.vue?vue&type=template&id=c12ff7b0"
import script from "./FormArray.vue?vue&type=script&lang=js"
export * from "./FormArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports